"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKilobytesFromString = (str) => {
    if (typeof Blob !== 'undefined') {
        return new Blob([str || '']).size / 1000;
    }
    return Buffer.byteLength(str || '', 'utf-8') / 1000;
};
//# sourceMappingURL=getKilobytesFromString.js.map